import React, { useMemo } from 'react';
import { Modal, Button } from 'antd';
import s from './s.module.less';

interface AvailabilityWarningModalProps {
    open: boolean;
    missingDays: string[];
    onAddAvailability: () => void;
    onContinue: () => void;
}

const AvailabilityWarningModal: React.FC<AvailabilityWarningModalProps> = ({
    open,
    missingDays,
    onAddAvailability,
    onContinue,
}) => {
    const formatDayName = (day: string): string => {
        return day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
    };

    const title = useMemo(() => {
        const validMissingDays = missingDays.filter((day) => day && day.trim().length > 0);

        if (validMissingDays.length === 1) {
            return `You're missing available hours on ${formatDayName(validMissingDays[0])}`;
        }
        return "You're missing available hours on several days";
    }, [missingDays]);

    return (
        <Modal
            open={open}
            onCancel={onAddAvailability}
            footer={null}
            width={420}
            centered
            closable
            className={s.modal}
        >
            <div className={s.content}>
                <div className={s.iconWrapper}>
                    <div className={s.iconBackground}>
                        <svg
                            className={s.icon}
                            xmlns="http://www.w3.org/2000/svg"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M16.5161 6.19716C18.0453 3.47855 21.9595 3.47855 23.4887 6.19716L34.6493 26.0382C36.1491 28.7047 34.2223 31.9993 31.163 31.9993H8.84176C5.78246 31.9993 3.8556 28.7047 5.35546 26.0382L16.5161 6.19716ZM22.0022 25.9995C22.0022 27.1041 21.1068 27.9995 20.0022 27.9995C18.8976 27.9995 18.0022 27.1041 18.0022 25.9995C18.0022 24.8949 18.8976 23.9995 20.0022 23.9995C21.1068 23.9995 22.0022 24.8949 22.0022 25.9995ZM20.0022 9.99951C18.8976 9.99951 18.0022 10.8949 18.0022 11.9995V17.9995C18.0022 19.1041 18.8976 19.9995 20.0022 19.9995C21.1068 19.9995 22.0022 19.1041 22.0022 17.9995V11.9995C22.0022 10.8949 21.1068 9.99951 20.0022 9.99951Z"
                                fill="#FBBF24"
                            />
                        </svg>
                    </div>
                </div>
                <h2 className={s.title}>{title}</h2>
                <div className={s.description}>
                    <p className={s.descriptionText}>
                        Having open hours every day helps you stay competitive.
                        Providers who do typically see up to 30% more bookings.
                    </p>
                    <p className={s.descriptionText}>
                        Add at least one hour each day to keep your schedule
                        active and visible.
                    </p>
                </div>
                <div className={s.buttonGroup}>
                    <Button
                        type="primary"
                        className={s.addButton}
                        onClick={onAddAvailability}
                    >
                        Add availability
                    </Button>
                    <Button className={s.continueButton} onClick={onContinue}>
                        Continue anyway
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default AvailabilityWarningModal;
